/**
 * 商品企画マスタ画面　束ね企画名情報VOクラス
 */

export class BundleCatalogRoundInfoListModel {

  public BundleCatalogRoundId: string = null;
  public MediumType: string = null;
  public MediumName: string = null;
  public StartOrderCode: string = null;
  public EndOrderCode: string = null;
  public BundleCatalogRoundName: string = null;
  public BundleCatalogOrderCodeList: Array<any>;
  public DelivCatalogId: string = null;
  public OrderCode: string = null;

}